import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import headerImg from './images/header.png';
import headerFreeImg from './images/headerfree.svg';
import leftArrow from './images/leftarrow.svg';
import { onFinishedWebView } from '../../helper/mobile';

const DietHeader = ({dietPlan, planType}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const goBackClickHandler = () => {
    if(location.pathname === '/diet/' || location.pathname === '/diet/one_month_smart_diet_plan')
     onFinishedWebView();
    else
      navigate(-1);
  }

  const getImgUrl = () => {
    if(dietPlan) {
      if(dietPlan.dietPlanType === 'one_month_smart_diet_plan'){
        return headerFreeImg
      }else {
        return headerImg
      }
    }else {
      if(planType === 'one_month_smart_diet_plan')
        return headerFreeImg
      else
        return headerImg
    }
  }

  return(
    <div className="position-relative">
      <img src={leftArrow} className="diet-left-arrow-header" onClick={goBackClickHandler} />
      <img src={getImgUrl()} className="header-img" />
    </div>
  );
}

export default DietHeader;